import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/header/Header';
import Footer from '../components/footer/Footer';
import { Accordion } from 'react-bootstrap-accordion';

const Contact = () => {
    const [data] = useState([
        {
            key: "0",
            show: true,
            title: 'SĐT & Zalo',
            text: '0969.920.950 - Mr. Quang'
        },
        {
            key: "1",
            show: true,
            title: 'Email',
            text: 'shukuchi@gmail.com'
        },
        {
            key: "2",
            show: true,
            title: 'Steam',
            text: (
                <a href="https://steamcommunity.com/id/shu0ku0chi" target="_blank" rel="noopener noreferrer">
                    Shu Ku Chi
                </a>
            ),
        },
        {
            key: "3",
            show: true,
            title: 'Facebook Profile',
            text:  (
                <a href="https://www.facebook.com/shu0ku0chi" target="_blank" rel="noopener noreferrer">
                    Đỗ Đức Quang
                </a>
            ),
        },
        {
            key: "4",
            show: true,
            title: 'Facebook Group',
            text:  (
                <a href="https://www.facebook.com/groups/cs2tradingmarket" target="_blank" rel="noopener noreferrer">
                    cs2tradingmarket
                </a>
            ),
        },
        {
            key: "5",
            show: true,
            title: 'Facebook Fanpage',
            text: (
                <a href="https://www.facebook.com/shuskincs2/" target="_blank" rel="noopener noreferrer">
                    shuskincs2
                </a>
            ),
        },
        {
            key: "6",
            show: true,
            title: 'Youtube Channel',
            text: (
                <a href="https://www.youtube.com/@ShuSkin" target="_blank" rel="noopener noreferrer">
                    ShuSkin
                </a>
            ),
        },
        {
            key: "7",
            show: true,
            title: 'Discord',
            text: (
                <a href="https://discord.gg/8zcdHrZh" target="_blank" rel="noopener noreferrer">
                    Join Now
                </a>
            ),
        },
    ]);

    return (
        <div>
            <Header />

            <section className="tf-section wrap-accordion">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="tf-title-heading ct style-2 fs-30 mg-bt-10">
                                Liên hệ
                            </h2>
                            <h5 className="sub-title help-center mg-bt-32 ">
                                Nếu có bất cứ thắc mắc nào vui lòng liên hệ với chúng tôi:
                            </h5>
                        </div>
                        <div className="col-md-12">
                            <div className="flat-accordion2">
                                {
                                    data.map((item, index) => (
                                        <div class="accordion-item">
                                            <p>{item.title}: {item.text}</p>
                                        </div>
                                    ))
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <Footer />
        </div>
    );
}

export default Contact;
